import {Button, Group, Paper, Switch, Text} from '@mantine/core'

type SaveBarProps = {
    userName: string | null
    errorCount: number
    saveError: string | null
    readyForDispatch: boolean
    saving: boolean
    readOnly: boolean
    onReadyForDispatchChange: (ready: boolean) => void
    onCancel: () => void
    onSave: () => void
}

export function SaveBar({
    userName,
    errorCount,
    saveError,
    readyForDispatch,
    saving,
    readOnly,
    onReadyForDispatchChange,
    onCancel,
    onSave,
}: SaveBarProps) {
    return (
        <Paper
            withBorder
            shadow="md"
            p="sm"
            radius="md"
            data-testid="job-entry-save-bar"
            style={{position: 'sticky', bottom: 8, zIndex: 20}}
        >
            <Group justify="space-between" gap="sm">
                <Group gap="md">
                    <Button variant="subtle" onClick={onCancel} disabled={saving}>
                        Cancel
                    </Button>
                    {userName ? (
                        <Text size="xs" c="dimmed">
                            Signed in as {userName}
                        </Text>
                    ) : null}
                </Group>
                <Group gap="md">
                    {errorCount > 0 ? (
                        <Text size="sm" c="red">
                            {errorCount === 1 ? '1 error' : `${errorCount} errors`}
                        </Text>
                    ) : saveError ? (
                        <Text size="sm" c="red" maw={360} lineClamp={2}>
                            {saveError}
                        </Text>
                    ) : null}
                    <Switch
                        label="Ready for dispatch"
                        checked={readyForDispatch}
                        onChange={(event) => onReadyForDispatchChange(event.currentTarget.checked)}
                    />
                    <Button
                        size="md"
                        loading={saving}
                        disabled={saving || readOnly}
                        onClick={onSave}
                    >
                        Save job
                    </Button>
                </Group>
            </Group>
        </Paper>
    )
}
